import { ENDPOINTS } from '@/config/endpoints'

// Initialize Everflow SDK and track click
export function initEverflow({ affId, offerId, params, onTransactionId }) {
  return new Promise((resolve) => {
    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.async = true

    script.onload = function() {
      EF.click({
        offer_id: offerId || 320,
        affiliate_id: affId,
        sub1: EF.urlParameter('s1'),
        sub2: params.has('reid') ? EF.urlParameter('reid') : EF.urlParameter('s2'),
        sub3: EF.urlParameter('s3'),
        sub4: EF.urlParameter('s4'),
        sub5: EF.urlParameter('s5'),
      }).then((transactionId) => {
        if (onTransactionId) {
          onTransactionId(transactionId)
        }
        resolve(transactionId)
      })
    }

    script.src = ENDPOINTS.EVERFLOW_SDK
    document.getElementsByTagName('head')[0].appendChild(script)
  })
}

// Load LP click tracking script
export function loadLpClickScript({ clickCampaignId, lpS5, lpS2, onRequestId }) {
  return new Promise((resolve) => {
    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.async = true

    script.onload = function() {
      if (typeof lp_request_id !== 'undefined' && lp_request_id) {
        if (onRequestId) {
          onRequestId(lp_request_id)
        }
        console.log('LP Request ID:', lp_request_id)
        resolve(lp_request_id)
      } else {
        resolve(null)
      }
    }

    script.src = `https://bluemodomedia.leadspediatrack.com/?c=${clickCampaignId}&t=p&s5=${lpS5}&s2=${lpS2}`
    document.getElementsByTagName('head')[0].appendChild(script)
  })
}

// Initialize Everflow with LP click tracking (combined flow)
export async function initEverflowWithClickTracking({ affId, offerId, clickCampaignId, params, onTransactionId, onRequestId }) {
  // First init Everflow
  const transactionId = await initEverflow({
    affId,
    offerId,
    params,
    onTransactionId
  })

  // If there's a click campaign, load it
  if (clickCampaignId) {
    await loadLpClickScript({
      clickCampaignId,
      lpS5: transactionId || '',
      lpS2: params.get('s2') || params.get('sub2') || '',
      onRequestId
    })
  }

  return transactionId
}

export const everflowService = {
  initEverflow,
  loadLpClickScript,
  initEverflowWithClickTracking
}
